import type Phaser from 'phaser';
import { ANIMATION } from '@/config/balance.config';

/**
 * Pokazuje "-X" floating up nad zaatakowanym obiektem.
 *
 * Wielkość czcionki skaluje się z wartością obrażeń (małe ataki = drobny tekst,
 * duże = grubo). Daje feedback "to było mocne uderzenie" bez specjalnych assetów.
 *
 * Po `durationMs` tekst się sam usuwa (alpha → 0 + Y rise).
 */
export function showDamagePopup(
  scene: Phaser.Scene,
  x: number,
  y: number,
  amount: number,
): void {
  const cfg = ANIMATION.damagePopup;

  // Skala wielkości tekstu: od fontSizeMin do fontSizeMax, lerp przez fontSizeScaleAt.
  const t = Math.min(1, amount / cfg.fontSizeScaleAt);
  const fontSize = Math.round(cfg.fontSizeMin + (cfg.fontSizeMax - cfg.fontSizeMin) * t);

  // Kolor: białe dla małych, żółty dla średnich, czerwone dla dużych.
  const color = amount >= cfg.fontSizeScaleAt ? '#ff5555'
    : amount >= cfg.fontSizeScaleAt / 2 ? '#ffd24a'
    : '#ffffff';

  const text = scene.add.text(x, y, `-${amount}`, {
    fontFamily: 'Baloo 2, sans-serif',
    fontSize: `${fontSize}px`,
    color,
    stroke: '#000000',
    strokeThickness: 3,
    fontStyle: 'bold',
  }).setOrigin(0.5).setDepth(70);   // > AtmosphereSystem vignette (62) — liczba musi zostać czytelna, też w rogach

  // Lekki losowy offset X żeby kolejne popupy się nie nakładały
  const driftX = (Math.random() - 0.5) * 20;

  scene.tweens.add({
    targets: text,
    x: x + driftX,
    y: y - cfg.riseDistance,
    alpha: 0,
    duration: cfg.durationMs,
    ease: 'Cubic.easeOut',
    onComplete: () => text.destroy(),
  });
}
